import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LazyDirective } from './lazy/lazy.directive';

@Component({
  selector: 'app-component-loader',
  standalone: true,
  imports: [CommonModule, LazyDirective],
  templateUrl: './component-loader.component.html',
  styleUrls: ['./component-loader.component.scss']
})
export class ComponentLoader implements OnChanges {

  @Input() load: boolean = false;
  @Input() selector: string = '';
  @Input() inputs: any;
  @Input() outputs: any;

  lazy_config: any;

  ngOnChanges(changes: SimpleChanges): void {
    if ((!changes?.['load']?.currentValue) || (changes?.['load']?.currentValue === changes?.['load']?.previousValue) || (changes?.['load']?.currentValue?.toString() === changes?.['load']?.previousValue?.toString())) {
      return;
    }
    this.loadLazyComponent();
  }

  loadLazyComponent() {
    if (!this.load) {
      return;
    }
    this.lazy_config = {
      component: this.getPath()
    }

  }

  getPath() {

    switch (true) {

      case this.selector === 'app-about-domain':
        return () => import('./../about-domain/about-domain.component');

      case this.selector === 'app-home-v2':
        return () => import('./../home-v2/home-v2.component');

      case this.selector === 'app-dm-v2':
        return () => import('./../dm-v2/dm-v2.component');

      case this.selector === 'app-extra-product-details':
        return () => import('../extra-product-details/extra-product-details.component');

      case this.selector === 'app-tax-benefit-nudge':
        return () => import('./../tax-benefit-nudge/tax-benefit-nudge.component');

      case this.selector === 'app-download-banner':
        return () => import('./../download-banner/download-banner.component');

      case this.selector === 'app-thankyou-sucess-head-v2':
        return () => import('./../thankyou-sucess-head-v2/thankyou-sucess-head-v2.component');

      case this.selector === 'app-sip-pitch-card-v5':
        return () => import('./..//sip-pitch-card-v5/sip-pitch-card-v5.component');

      case this.selector === 'app-multi-patient-dropdown':
        return () => import('./../multi-patient-dropdown/multi-patient-dropdown.component');

      case this.selector === 'app-multicause-slab':
        return () => import('./../multicause-slab/multicause-slab.component');

      case this.selector === 'app-multicause-sip-v2':
        return () => import('./../multicause-sip-v2/multicause-sip-v2.component');

      case this.selector === 'app-sip-hamburger':
        return () => import('./../sip-hamburger/sip-hamburger.component');

      case this.selector === 'app-home-urgent-banner-v2':
        return () => import('./../home-urgent-banner-v2/home-urgent-banner-v2.component');

      case this.selector === 'testing':
        return () => import('./../testing/testing.component');

      case this.selector === 'app-partner-plan-upgrade-nudge':
        return () => import('./../partner-plan-upgrade-nudge/partner-plan-upgrade-nudge.component');

      case this.selector === 'app-urgent-tag':
        return () => import('./../urgent-tag/urgent-tag.component');

      case this.selector === 'app-bene-hosp':
        return () => import('./../../story/components/bene-hosp/bene-hosp.component');

      case this.selector === 'app-med-doc-place-holder':
        return () => import('./../med-doc-place-holder/med-doc-place-holder.component');

      case this.selector === 'app-supporters-place-holder':
        return () => import('./../supporters-place-holder/supporters-place-holder.component');

      case this.selector === 'app-csat':
        return () => import('./../csat/csat.component');

      case this.selector === 'app-otd-card-onetap':
        return () => import('../otd-card-onetap/otd-card-onetap.component');

      case this.selector === 'app-sip-pitch-card':
        return () => import('../sip-pitch-card/sip-pitch-card.component');

      case this.selector === 'app-story-ab':
        return () => import('../../fundraiser/components/story-ab/story-ab.component');

      case this.selector === 'app-sip-pitch-otd':
        return () => import('../sip-pitch-otd/sip-pitch-otd.component');

      case this.selector === 'app-lead-gen-phone':
        return () => import('../lead-gen-phone/lead-gen-phone.component');

      case this.selector === 'app-bill-pay-pitch':
        return () => import('../bill-pay-pitch/bill-pay-pitch.component');

      case this.selector === 'app-tip-toggle':
        return () => import('../tip-toggle/tip-toggle.component');

      case this.selector === 'app-thankyou-page-tip':
        return () => import('../thankyou-page-tip/thankyou-page-tip.component');

      case this.selector === 'app-dm-story-footer':
        return () => import('../../pages/dm-story/components/dm-story-footer/dm-story-footer.component');

      default:
        return;
    }

  }

}
